'use client';

import React, { useEffect } from 'react';

import { Box, BoxContent, SpacerSize, Title, TitleLevels, TitleMarkup } from '@bytel/trilogy-react';

import { ResponsiveSpacer } from '@components/responsive-spacer';

import { scrollToHash } from '@helpers/document';

export type CategoryBoxProps = {
    title: string;
    isLoading?: boolean;
    formId?: string;
    children: React.ReactNode;
};

export function CategoryBox({ title, isLoading, formId, children }: Readonly<CategoryBoxProps>) {
    useEffect(() => {
        if (window.location.hash === `#${formId}`) {
            scrollToHash();
        }
    }, [formId]);

    return (
        <>
            <Box shadowless skeleton={isLoading} className='remove-section-padding box-container'>
                <BoxContent>
                    <Title markup={TitleMarkup.H2} level={TitleLevels.FOUR}>
                        {title}
                    </Title>
                    <form id={formId} className='ignore-sticky-scroll'>
                        {children}
                    </form>
                </BoxContent>
            </Box>
            <ResponsiveSpacer mobileSize={SpacerSize.SIX} desktopSize={SpacerSize.FIVE} />
        </>
    );
}
